<template>
  <div>
  <sea-page title="Lista consulenti" header="Lista consulenti">
    <sea-page-content
      ref="list"
      :fetchList="fetchList"
      :resetList="resetList"
      :deleteItems="deleteSelected"
      toolbar
      pulsanteAggiorna
      max
      pulsanteElimina
      :pulsanteEliminaDisabled="!currentRow || currentRow.activated"
    >
      <template v-slot:toolbar>
        <table-toolbar-button
          type="CREATE"
          @click="createItem"
        ></table-toolbar-button>
        <table-toolbar-button
          type="UPDATE"
          @click="updateItem"
          :disabled="!currentRow"
        ></table-toolbar-button>
        <table-toolbar-button
          icon="mdi-email-send"
          label="Invia e-mail credenziali primo accesso"
          @click="sendActivationEmail"
          :disabled="!currentRow || currentRow.activable"
        ></table-toolbar-button>
        <table-toolbar-button
          icon="mdi-lock-reset"
          label="Reset password"
          @click="resetPasswordInit"
          :disabled="!currentRow || !currentRow.activated"
        ></table-toolbar-button>
        <table-toolbar-button
          icon="mdi-account-reactivate"
          label="Disabilita/Abilita utenza"
          @click="activationUser"
          :disabled="!currentRow || !currentRow.activable"
        ></table-toolbar-button>
      </template>
      <v-row v-if="totaleUtentiAttivabili">
        <v-col class="text-formatter-totali" offset-sm="9" cols="3"> 
          <v-row>
            <v-col class="text-align-end" cols="10">
              Totale utenti attivabili:
            </v-col>
            <v-col class="text-align-start" cols="1">
              {{ totaleUtentiAttivabili }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2"></v-col>
      </v-row>
      <v-row v-if="totaleUtentiAttivati">
        <v-col class="text-formatter-totali" offset-sm="9" cols="3">
          <v-row>
            <v-col class="text-align-end" cols="10">
              Totale utenti attivati:
            </v-col>
            <v-col cols="1" class="text-align-start">
              {{ totaleUtentiAttivati }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <template v-slot:table="{ attrs, height }">
        <v-data-table
          v-model="attrs.selected"
          v-bind="attrs"
          :height="height"
          :headers="headers"
          :items="items"
          sort-by="email"
          dense
          show-select
          item-key="id"
          single-select
          @item-selected="itemSelected"
          @click:row="rowClick"
        >
          <template v-slot:item.activated="{ item }">
            <check-icon :checked="item.activated"></check-icon>
          </template>
          <template v-slot:item.utentiAttivati ="{ item }">
            <v-row>
              <v-col class="text-align-end" cols="3">
                {{ item.utentiAttivati }}
              </v-col>
              <v-col class="text-align-end" cols="2">
                <span v-if="item.utentiAttivati">
                  <v-btn
                    elevation="2"
                    rounded
                    x-small
                    :color="colors.primarycolor"
                    dark
                    @click="openModaleUtentiAttivatiConfirm(item)"
                  >
                    Dettaglio
          </v-btn></span>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.usato="{ item }">
            <v-row>
              <v-col class="text-align-end" cols="12">
                {{ item.usato/1024/1024 | roundNumber }}
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.quota="{ item }">
            {{ item.quota/1024/1024 | roundNumber }}
          </template>
        </v-data-table>
      </template>
    </sea-page-content>
  </sea-page>
  <sea-dialog
    ref="modaleUtentiAttivabili"
    title=" Lista utenti"
    confirmLabel="ESPORTA DATI"
    @confirmed="print"
    maxWidth="1000px"
    >
    <div class="div-lista-utenti">
        <v-data-table
          :headers="listaUtentiHeaders"
          :items="listaUtenti"
          disable-filtering
          disable-pagination
          disable-sort
          hide-default-footer
          fixed-header
          height="400">
          <template v-slot:item.user_type="{ item }">
            <span v-if="item.user_type == 'A'">
                  <v-icon title="Azienda">mdi-domain</v-icon> Azienda
                </span>
                <span v-if="item.user_type == 'D'">
                  <v-icon title="Dipendente">mdi-account-hard-hat</v-icon> Dipendente
                </span>
          </template>
        </v-data-table>
    </div>
  </sea-dialog>
</div>
</template>


<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
//import { UtenteAutenticatoDto } from  "../../store/account";

import mixin from "@/mixin";
const headers = [
  { text: "", value: "data-table-select" },
  { text: "Login", value: "login" },
  { text: "Nome", value: "firstName" },
  { text: "Cognome", value: "lastName" },
  { text: "Cod. fiscale", value: "codFiscale" },
  { text: "Cod. cliente", value: "codCliente" },
  { text: "Cod. prodotto", value: "numProdotto" },
  { text: "Cod. distr.", value: "codDistribuzione" },
  { text: "Email", value: "email" },
  {
    text: "Attivo",
    value: "activated",
    fileterable: false,
    sortable: false,
    align: "center",
  },
  { text: "Utenti attivabili", value: "utentiAttivabili" },
  { text: "Utenti attivati", value: "utentiAttivati" },
  { text: "Spazio usato /MB", value: "usato" },
  { text: "Quota /MB", value: "quota" },
];


const listaUtentiHeaders = [
  { text: "Tipo", value: "user_type" },
  { text: "Nome", value: "first_name" },
  { text: "Cognome", value: "last_name" },
  { text: "Login", value: "login" },
  { text: "", value: "totaledipendenti"}

];

export default {
  mixins: [mixin],
  data() {
    return {
      headers,
      listaUtentiHeaders,
      selected: [],
      currentRow: null,
      listaUtenti: [],
    };
  },
  methods: {
    rowClick: function (item, row) {
      row.select(!row.isSelected);
    },
    ...mapActions({
      fetchList: "users/fetchConsultants",
      fetchUtentiAttivi: "users/fetchUtentiAttivi",
      delete: "users/deleteUser",
      _activationUser: "users/activationUser",
      _sendActivationEmail: "account/sendActivationEmail",
      _resetPasswordInit: "account/resetPasswordMail",
    }),
    ...mapMutations({
      resetList: "users/RESET_EMPLOYEES",
    }),
    createItem() {
      this.$router.push("/admin/consultant/new");
    },
    updateItem() {
      this.$router.push(`/admin/consultant/${this.currentRow.login}/edit`);
    },
    itemSelected(payload) {
      this.currentRow = payload.value ? payload.item : null;
    },
    activationUser() {
      if (this.currentRow) {
        this.currentRow.activated = !this.currentRow.activated;
        this._activationUser(this.currentRow);
      }
    },
    sendActivationEmail() {
      if (this.currentRow) {
        this._sendActivationEmail(
          {
            id: this.currentRow.id,
            email: this.currentRow.email,
          }
        );
      }
    },
    resetPasswordInit() {
      if (this.currentRow) {
        this._resetPasswordInit(this.currentRow.login);
      }
    },
    confirm() {
      this.$refs.list.openDeleteConfirm();
    },
    async deleteSelected() {
      await this.delete(this.currentRow.login);
      this.currentRow = null;
      await this.$refs.list.updateList();
    },
    openModaleUtentiAttivatiConfirm(item) {
        this.fetchUtentiAttivi(item).then(() => {
        this.listaUtenti = this.resUtentiAttivi;

        this.listaUtenti.forEach((user, index) => {
            if (user.user_type === "A") {
                let count = 0;
                for (let i = index + 1; i < this.listaUtenti.length; i++) {
                    if (this.listaUtenti[i].user_type === "D") {
                        count++;
                    } else {
                        break;
                    }
                }
                user.totaledipendenti = count;
            }
        });

        console.log(this.listaUtenti);
        this.$refs.modaleUtentiAttivabili.open();
      })
    },
    disabledEsportaDatiListaUtenti(){
      const findElement = this.listaUtenti.find(x => x.selected === true);
      return findElement ? true : false;
    },
    print() {
      var source = this.listaUtenti;
      let rows = [];
       var doc  = new jsPDF('l', 'mm', 'a4');
      let columnHeader = ["Tipo", "Nome", "Cognome", "Login", "Totale dipendenti per azienda"];
      let pdfName = "Lista utenti attivabili";
      source.forEach(element => {
        var tipoUtente = element.user_type === 'A' ? 'Azienda' : (element.user_type === 'D' ? 'Dipendente' : '');
        var temp = [
          tipoUtente, element.first_name, element.last_name, element.login, element.totaledipendenti
        ];
        rows.push(temp);
      });
      doc.horizontalPageBreak = true;
      var y = 10;
      doc.setLineWidth(1);
      doc.text(90, y = y + 1, "Lista utenti Attivati");
      doc.setTextColor(0, 102, 204);
      doc.autoTable(columnHeader, rows, 
      { 
        theme: 'grid',
        headStyles :{lineWidth: 0, fillColor: [0, 102, 204],textColor: [255,255,255],},
            
        startY: 20, 
        styles: {
         horizontalPageBreak : true
        },
        columnStyles: {5: {columnWidth: 50}}
      });
      doc.save(pdfName + '.pdf');
    }, 
  },

  computed: {
    ...mapGetters({
      items: "users/consultants",
      totaleUtentiAttivabili: "users/totaleUtentiAttivabili",
      totaleUtentiAttivati: "users/totaleUtentiAttivati",
      resUtentiAttivi: "users/utentiAttivi",
    }),
  },
};
</script>

<style>
.text-align-start {
  text-align: start;
}
.text-align-end {
  text-align: end;
}
.text-formatter-totali{
  font-weight: bold;
  text-transform: uppercase;
  padding: 0px;
  padding-right: 40px;
}
.div-lista-utenti{
  max-height: 500px;
  overflow-y: auto;
}
</style>
